import GeoTop5 from './GeoTop5';

export default (props) => <GeoTop5 {...props} />;
